// PickupTimeAPI.js
import axiosInstance from "./AxiosInstance";
import store from "@/store";

/**
 * API for interacting with pickupTime related endpoints.
 */
const PickupTimeAPI = {
  /**
   * Retrieves all pickup times based on predefined parameters.
   *
   * @returns {Promise<AxiosResponse>} A promise that resolves to the response containing the pickup times.
   */
  getAllPickupTimes: (pickupPointsId, postalCode) => {
    const params = {
      point: pickupPointsId,
      postalCode: postalCode, // Get the point ID from Vuex store
      fromDate: new Date().toISOString(), // Set fromDate to today's date
      hasSpace: false,
    };
    return axiosInstance.get("/pickupTime", { params });
  },
};

export default PickupTimeAPI;
